// extracted by mini-css-extract-plugin
export var container = "_h4-0";
export var content = "_h4-3";
export var customerTitle = "_h4-4";
export var empty = "_h4-5";
export var gray = "_h4-6";
export var header = "_h4-7";
export var info = "_h4-8";
export var loading = "_h4-2";
export var loadingCard = "_h4-9";
export var oneLine = "_h4-a";
export var personName = "_h4-e";
export var pillContainer = "_h4-b";
export var selected = "_h4-1";
export var text = "_h4-c";
export var twoLines = "_h4-d";
export var unread = "_h4-f";
export var unreadIndicator = "_h4-g";